module.exports = __webpack_public_path__ + "img/schedule-header.0f330210.png";